'use client';

import { Box } from '@chakra-ui/react';
import React from 'react';

import {
  BodyTypeList,
  BrandAndRangesType,
  ColourTypeList,
  Consumption,
  DealershipsByProvince,
  DoorTypeList,
  DriveTypeList,
  FeatureTypeList,
  FuelTypeList,
  MileageType,
  TransmissionTypeList,
  YearType,
} from '@/services/filters/new-filters.service';

import {
  getFilterCounts,
  Params,
} from '../../search/search-results/search-params';

import { NewBody } from './new-body/new-body';
import { NewBrandsRanges } from './new-brand-ranges/new-brand-ranges';
import { NewFeatures } from './new-features/new-features';
import styles from './new-filters.module.scss';
import { NewLocation } from './new-location/new-location';
import { NewMoreFilters } from './new-more-filters/new-more-filters';
import { NewPrices } from './new-prices/new-prices';
import { NewYearsMileage } from './new-years-mileage/new-years-mileage';

export interface NewFiltersProps {
  brandsAndRanges: BrandAndRangesType;
  maxPrice: number;
  bodyTypes: BodyTypeList;
  colourTypes: ColourTypeList;
  doorTypes: DoorTypeList;
  defaultFuelConsumption: Consumption;
  transmissionTypes: TransmissionTypeList;
  driveTypes: DriveTypeList;
  fuelTypes: FuelTypeList;
  years: YearType;
  mileages: MileageType;
  dealershipsByProvince: DealershipsByProvince;
  params: Params;
  defaultFilters: DefaultFilters;
  features: FeatureTypeList;
  isLocationHidden?: boolean;
}

export type DefaultFilters = {
  defaultMake?: string;
  defaultModel?: string;
  defaultLocation?: string;
  defaultMaxPrice?: number;
  defaultDealershipId?: string;
};

export default function NewFilters({
  brandsAndRanges,
  bodyTypes,
  colourTypes,
  doorTypes,
  defaultFuelConsumption,
  maxPrice,
  dealershipsByProvince,
  transmissionTypes,
  driveTypes,
  fuelTypes,
  years,
  mileages,
  params,
  defaultFilters,
  features,
  isLocationHidden,
}: NewFiltersProps) {
  const filterCounts = getFilterCounts(params);

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
      mt={{
        base: 4,
        lg: 0,
      }}
      gap={{
        base: '16px',
        xl: '5px',
      }}
      className={styles.filters}
    >
      <NewBrandsRanges
        count={filterCounts.brandsAndRanges}
        brandsAndRanges={brandsAndRanges}
        defaultMake={defaultFilters.defaultMake}
        defaultModel={defaultFilters.defaultModel}
      />
      <NewBody
        bodyTypes={bodyTypes}
        colourTypes={colourTypes}
        doorTypes={doorTypes}
        count={filterCounts.body}
      />
      {!isLocationHidden ? (
        <NewLocation
          dealershipsByProvince={dealershipsByProvince}
          count={filterCounts.location}
          defaultLocation={defaultFilters?.defaultLocation}
          defaultDealershipId={defaultFilters?.defaultDealershipId}
        />
      ) : null}
      <NewPrices count={filterCounts.price} maxPrice={maxPrice} defaultMaxPrice={defaultFilters.defaultMaxPrice} />
      <NewYearsMileage
        count={filterCounts.yearsAndMileage}
        years={years}
        mileages={mileages}
      />
      <NewFeatures count={filterCounts.features} featureCounts={features} />
      <NewMoreFilters
        defaultFuelConsumption={defaultFuelConsumption}
        transmissionTypes={transmissionTypes}
        driveTypes={driveTypes}
        fuelTypes={fuelTypes}
        count={filterCounts.more}
      />
    </Box>
  );
}
